<template>
    <PopupRouterViewDetail label="Scanner Error Log Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Scanner Error Log" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-datetimepicker id="fieldset-log-date" label-cols-lg="12"  label="Log Date" size="sm" :model.sync="model.logDate" :isRequired="true" :state="validateState('logDate')" :errorMessage="getErrorMessage(errorMessage.logDate, 'logDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId" :isRequired="true" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" @change="updateData"  :isUpdatable="true" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData"  :isUpdatable="true" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId" :isRequired="true" :state="validateState('customerId')" :errorMessage="getErrorMessage(errorMessage.customerId, 'customerId')"   :selected="model.customer != null ? model.customer.code : ''" @input="getCustomers" @change="updateData"  :isUpdatable="true" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedCustomer" />
						<app-input-textbox id="fieldset-case-qty" label-cols-lg="12"  label="Case Qty" label-for="input-case-qty" size="sm" :model.sync="model.caseQty"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-input-textbox id="fieldset-transaction-type" label-cols-lg="12"  label="Transaction Type" label-for="input-transaction-type" size="sm" :model.sync="model.transactionType"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-input-textbox id="fieldset-transaction-id" label-cols-lg="12"  label="Transaction Id" label-for="input-transaction-id" size="sm" type="number" :model.sync="model.transactionId"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Pic" id="fieldset-user" size="sm" :model.sync="model.userUserName"   :selected="model.user != null ? model.user.firstName : ''" @input="getUserInfos" @change="updateData"  :isUpdatable="true" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedUser" />
						<app-input-textarea id="fieldset-err-message" label-cols-lg="12"  label="ErrMessage" label-for="input-err-message" size="sm" :model.sync="model.errMessage"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-input-textbox id="fieldset-input-type" label-cols-lg="12"  label="Input Type" label-for="input-input-type" size="sm" :model.sync="model.inputType"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-input-textbox id="fieldset-input-type-id" label-cols-lg="12"  label="Input Type Id" label-for="input-input-type-id" size="sm" type="number" :model.sync="model.inputTypeId"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ScannerErrorLog from '@/models/ScannerErrorLog/ScannerErrorLog';
import ScannerErrorLogList from '@/models/ScannerErrorLog/ScannerErrorLogList';
import ScannerErrorLogFilter from '@/filters/ScannerErrorLog/ScannerErrorLogFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			logDate: {required},
			controlCardId: {required},
			partId: {required},
			customerId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				logDate: { required : "Log Date is Required."},
				controlCardId: { required : "Control Card is Required."},
				partId: { required : "Part is Required."},
				customerId: { required : "Customer is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterScannerErrorLog : null,
			currentScannerErrorLogPage : 1,
			scannerErrorLogPageSize: 10,
			sortByScannerErrorLog: '',
			sortDescScannerErrorLog: '',
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			parts: [],
			parts: [],
			isPartComboLoading: false,
			customers: [],
			customers: [],
			isCustomerComboLoading: false,
			userInfos: [],
			users: [],
			isUserComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			isCustomerComboLoading: false,
			isUserInfoComboLoading: false,
		}
	},
	methods : {
		getScannerErrorLog : async function(id) {
			this.isBusy = true;
			ScannerErrorLog.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadScannerErrorLog = true;
			this.filterScannerErrorLog.id = this.modelId;
			ScannerErrorLog.downloadDataDetail(this, this.filterScannerErrorLog).then(result => {
				this.isDownloadScannerErrorLog = false;
			}).catch(error => { this.isDownloadScannerErrorLog = false; })
		},
		getScannerErrorLogs : async function(input) {
			let filter = new ScannerErrorLogFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isScannerErrorLogComboLoading = true;
			ScannerErrorLog.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.scannerErrorLogs = result.data
				}
				this.isScannerErrorLogComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedCustomer(item) {
			if(item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedUser(item) {
			if(item == undefined || item == null) {
				this.model.userUserName = null;
				this.model.user = null;
			} else {
				this.model.userUserName = item.userName;
				this.model.user = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.scannerErrorLogInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						ScannerErrorLog.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'scannererrorlogindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						ScannerErrorLog.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'scannererrorlogindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ScannerErrorLog.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getScannerErrorLog(id);
					});
				}
			});
		},
		onHidden() {
			this.getScannerErrorLogs();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterScannerErrorLog = new ScannerErrorLogFilter();
		//this.getControlCards();
		//this.getParts();
		//this.getCustomers();
		//this.getUserInfos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getScannerErrorLog(id);
			} else {
				this.modelId = id;
				this.getScannerErrorLog(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
